import React from 'react'
import ShareButton from 'components/ShareButton'
import moment from 'moment-timezone';
import Section from 'components/Section'
import Image from 'react-bootstrap/Image'
import Spinner from "react-bootstrap/Spinner";
 
function ClassLocationSection(props) {

    const {value, classId, reserved} = props

    const {isLoading} = props

    var viewModel = {
        name: value?.name ?? value?.class_name,
        timeString: moment((value?.start_time ?? 0) * 1000).format("ddd MMM Do • h:mma - ") + moment(((value?.start_time ?? 0) + ((value?.duration ?? 60) * 60)) * 1000).format("h:mma") + ` ${moment.tz(moment.tz.guess()).format('z')}`,
        instructorName: value?.instructor_name ?? "",
        image: (value?.images && value.images.length > 0) ? value.images[0] : ""
    }
    
  
    return (
        <>
        <div className="">
            {/* {true ? ( */}
            {reserved ? (
            <>

                {value?.location_type === "inperson" && (<>
                    <h5 className="font-weight-bold">{value?.location?.cityState}</h5>
                    <h6 className="">{value?.location?.address}</h6>
                    <a
                    target="_blank"
                    href={value?.location?.contentLink}
                    className="btn btn-primary primaryColor">Open Maps</a>
                    
                </>)}

                {value?.location_type !== "inperson" && (<>
                    <h5 className="font-weight-bold">Online Class</h5>
                    <p>Congrats you're checked in! You will also receive a link to access in your confirmation email</p>
                    <button 
                    className="btn btn-primary primaryColor mb-2"
                    // href={value.content_link ?? value.reserve_link}
                    onClick={() => {
                        window.open(value?.content_link ?? value?.reserve_link)
                    }}
                    target="_blank"
                    >
                        Launch Class
                    </button>
                    <div className="d-flex d-row align-items-center"
                    style={{maxWidth: "300px"}}
                    >
                        <input
                        style={{paddingRight: "50px"}}
                        type="text" 
                        value={value?.content_link ?? value?.reserve_link}
                        readOnly={true} className={"form-control"}/>
                        <ShareButton 
                        link={value?.content_link ?? value?.reserve_link}
                        style={{marginLeft: "-50px"}}
                        />
                    </div>
                    
                </>)}

                <div className='mt-3'>
                    <h5 className="font-weight-bold">Add to calendar</h5>
                    <a
                    target="_blank"
                    href={`http://sutrapro.com/api/calendar/google?classId=${classId}`}
                    className="btn btn-link primaryColor px-0 mr-3">Google</a>
                    <a 
                    target="_blank"
                    href={`http://sutrapro.com/api/calendar/apple?classId=${classId}`}
                    className="btn btn-link primaryColor px-0 mr-3">Apple</a>
                {/* http://sutrapro.com/api/calendar/google?classId
                http://sutrapro.com/api/calendar/apple?classId={{classId}} */}
                </div>

            </>

            ) : (

                <button 
                disabled={isLoading}
                className="btn btn-primary primaryColor mb-2"
                // href={value.content_link ?? value.reserve_link}
                onClick={() => {
                    if (props.onReserveClass) {
                        props.onReserveClass(classId)
                    }
                }}
                target="_blank"
                >
                    <span>Check in for class</span>
                    {isLoading && (
                        <Spinner
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden={true}
                        className="ml-2"
                        >
                        </Spinner>
                    )}
                </button>

            )}
            
        </div>
      </>
    );
}

export default ClassLocationSection